import type { Block, Envelope } from './types';

export function timeAxis(days: Array<string>, block: Block, envelope: Envelope, range?: { from: string; to: string }) {
  const grain = block.grain ?? envelope.period.grain;
  const intraday = grain === 'minute' || grain === 'hour';
  if (!intraday) {
    return { days, tick: undefined, label: undefined };
  }
  const step = grain === 'minute' ? 1 : 60;
  const full = block.xRange !== 'data';
  const start = range?.from ?? (full ? `${envelope.period.current.from}T00:00` : days[0]);
  const end =
    range?.to ??
    (full
      ? new Date(Date.parse(`${envelope.period.current.to}T00:00:00Z`) + 86_400_000).toISOString().slice(0, 16)
      : days[days.length - 1]);
  const slots: Array<string> = [];
  if (start && end) {
    const from = Date.parse(`${start}:00Z`);
    const to = Date.parse(`${end}:00Z`);
    if (Number.isFinite(from) && Number.isFinite(to) && (to - from) / (step * 60_000) <= 10_000) {
      for (let at = from; at <= to; at += step * 60_000) {
        slots.push(new Date(at).toISOString().slice(0, 16));
      }
    }
  }
  const times = slots.length ? slots : days;
  const span = Math.max(1, times.length - 1) * step;
  const every = [15, 30, 60, 120, 240, 360, 720, 1440].find((value) => value >= span / 6) ?? 1440;
  const requested =
    typeof block.xTick === 'number' && Number.isSafeInteger(block.xTick) && block.xTick > 0 ? block.xTick : every;
  const interval = Math.ceil(requested / step) * step;
  const origin = Date.parse(`${envelope.period.current.from}T00:00:00Z`);
  const singleDay = envelope.period.current.from === envelope.period.current.to;
  return {
    days: times,
    tick: (index: number, time: string) =>
      index === 0 || index === times.length - 1 || ((Date.parse(`${time}:00Z`) - origin) / 60_000) % interval === 0,
    label: (time: string) =>
      full && !range && singleDay && time === end
        ? '24:00'
        : !singleDay
          ? `${time.slice(8, 10)}/${time.slice(5, 7)}${time.slice(11, 16) === '00:00' ? '' : ` ${time.slice(11, 16)}`}`
          : time.slice(11, 16),
  };
}
